export default function Footer() {
  return (
    <footer className="px-4 py-6 text-center text-sm text-gray-400">
      <div className="flex items-center justify-center gap-2 mb-4">
        <span>Bookings:</span>
        <a href="mailto:marcel@muzink.nl" className="text-gray-400 hover:text-white underline transition-colors">
          marcel@muzink.nl
        </a>
      </div>
      <div className="flex items-center justify-center gap-2 mb-4">
        <span>Demos:</span>
        <a href="mailto:demo@barankamusic.nl" className="text-gray-400 hover:text-white underline transition-colors">
          demo@barankamusic.nl
        </a>
      </div>
      <div className="mt-2">© {new Date().getFullYear()} Fresku</div>
    </footer>
  );
} 